var $ = require('jquery');

$('.productData__navArrow--next').click(function() {
    $('.productData__inner').animate({
        scrollLeft: '+=250px'
    }, 'slow');
});

$('.productData__navArrow--prev').click(function() {
    $('.productData__inner').animate({
        scrollLeft: '-=250px'
    }, 'slow');
});



// WEBPACK FOOTER //
// ./src/pages/product/productData.js